import request from '@/plugins/axios'


//查询单个频道/栏目-详细信息
export function getWebsiteColumn(params) {
  return request({
    url: '/website/getWebsiteColumn/' + params,
    method: 'get'
  })
}

//删除网站栏目
export function deleteWebsiteColumn(params) {
  return request({
    url: '/website/deleteWebsiteColumn/' + params,
    method: 'get'
  })
}

//创建网站栏目
export function addWebsiteColumn(data) {
  return request({
    url: '/website/addWebsiteColumn',
    method: 'post',
    data
  })
}

//修改网站栏目
export function updateWebsiteColumn(data) {
  return request({
    url: '/website/updateWebsiteColumn',
    method: 'post',
    data
  })
}


//获取网站栏目列表
export function listWebsiteColumn(params) {
  return request({
      url: '/website/listWebsiteColumn',
      method: 'get',
      params
  })
}



//查询单个轮播图-详细信息
export function getWebsiteCarousel(params) {
  return request({
    url: '/website/getWebsiteCarousel/' + params,
    method: 'get'
  })
}

//删除轮播图
export function deleteWebsiteCarousel(params) {
  return request({
    url: '/website/deleteWebsiteCarousel/' + params,
    method: 'get'
  })
}

//创建轮播图
export function addWebsiteCarousel(data) {
  return request({
    url: '/website/addWebsiteCarousel',
    method: 'post',
    data
  })
}

//修改轮播图
export function updateWebsiteCarousel(data) {
  return request({
    url: '/website/updateWebsiteCarousel',
    method: 'post',
    data
  })
}


//获取轮播图列表
export function listWebsiteCarousel(params) {
  return request({
      url: '/website/listWebsiteCarousel',
      method: 'get',
      params
  })
}



//查询单个展示信息
export function getWebsiteShowInfo(params) {
  return request({
    url: '/website/info/getWebsiteShowInfo/' + params,
    method: 'get'
  })
}

//删除展示信息
export function deleteWebsiteShowInfo(params) {
  return request({
    url: '/website/info/deleteWebsiteShowInfo/' + params,
    method: 'get'
  })
}

//创建展示信息
export function addWebsiteShowInfo(data) {
  return request({
    url: '/website/info/addWebsiteShowInfo',
    method: 'post',
    data
  })
}

//修改展示信息
export function updateWebsiteShowInfo(data) {
  return request({
    url: '/website/info/updateWebsiteShowInfo',
    method: 'post',
    data
  })
}


//获取展示信息列表
export function listWebsiteShowInfo(params) {
  return request({
      url: '/website/info/listWebsiteShowInfo',
      method: 'get',
      params
  })
}